import { GraphNode, GraphEdge } from '@/types/graph';

export const EXAMPLE_GRAPH_NODES: GraphNode[] = [
  // Organizations
  {
    id: 'org-1',
    name: 'ABC Construction Ltd',
    type: 'organization',
    aliases: ['ABC Construction', 'ABC Ltd'],
    attributes: {
      sector: 'Construction',
      headquarters: 'Nairobi, Kenya',
      yearFounded: 2010,
      employees: 2500,
    },
    confidence: 0.95,
    sources: { government: 8, legal: 5, news: 12, audit: 3, social: 0 },
    connectionCount: 8,
    firstSeen: '2022-01-15',
    lastUpdated: '2024-03-01',
    position: { x: 0, y: 0 },
  },
  {
    id: 'org-2',
    name: 'Ministry of Transport',
    type: 'organization',
    aliases: ['MoT', 'Transport Ministry'],
    attributes: {
      sector: 'Government',
      agencyType: 'Government Agency',
      yearFounded: 1999,
    },
    confidence: 0.98,
    sources: { government: 20, legal: 8, news: 15, audit: 5, social: 0 },
    connectionCount: 12,
    firstSeen: '2021-06-10',
    lastUpdated: '2024-03-01',
    position: { x: 200, y: -150 },
  },
  {
    id: 'org-3',
    name: 'Kenya National Highways Authority',
    type: 'organization',
    aliases: ['KeNHA'],
    attributes: {
      sector: 'Government',
      agencyType: 'Government Agency',
      yearFounded: 2014,
    },
    confidence: 0.97,
    sources: { government: 18, legal: 6, news: 10, audit: 4, social: 0 },
    connectionCount: 6,
    firstSeen: '2022-03-20',
    lastUpdated: '2024-03-01',
    position: { x: 200, y: 150 },
  },
  // Persons
  {
    id: 'person-1',
    name: 'James Mwangi',
    type: 'person',
    aliases: ['J. Mwangi'],
    attributes: {
      title: 'Director',
      age: 48,
      nationality: 'Kenyan',
    },
    confidence: 0.92,
    sources: { government: 5, legal: 8, news: 15, audit: 2, social: 3 },
    connectionCount: 5,
    firstSeen: '2022-02-01',
    lastUpdated: '2024-03-01',
    position: { x: -100, y: -100 },
  },
  {
    id: 'person-2',
    name: 'Sarah Kimani',
    type: 'person',
    aliases: ['S. Kimani', 'Sarah K.'],
    attributes: {
      title: 'CFO',
      age: 45,
      nationality: 'Kenyan',
    },
    confidence: 0.88,
    sources: { government: 2, legal: 4, news: 8, audit: 1, social: 2 },
    connectionCount: 3,
    firstSeen: '2022-05-15',
    lastUpdated: '2024-03-01',
    position: { x: -100, y: 100 },
  },
  // Contracts
  {
    id: 'contract-1',
    name: 'Western Bypass Phase III Highway Construction Contract',
    type: 'contract',
    aliases: ['WBP3 Contract', 'Highway Contract 2024'],
    attributes: {
      value: 2400000000,
      currency: 'KES',
      awardDate: '2023-06-15',
      status: 'Active',
    },
    confidence: 0.96,
    sources: { government: 10, legal: 8, news: 12, audit: 6, social: 0 },
    connectionCount: 6,
    firstSeen: '2023-06-15',
    lastUpdated: '2024-03-01',
    position: { x: -300, y: 0 },
  },
  // Projects
  {
    id: 'project-1',
    name: 'Western Bypass Phase III',
    type: 'project',
    aliases: ['WBP3', 'Highway Project 2024'],
    attributes: {
      status: 'In Progress',
      location: 'Nairobi, Kenya',
      budget: 2400000000,
      progress: 45,
    },
    confidence: 0.94,
    sources: { government: 12, legal: 6, news: 14, audit: 5, social: 1 },
    connectionCount: 7,
    firstSeen: '2023-03-01',
    lastUpdated: '2024-03-01',
    position: { x: 0, y: -300 },
  },
  // Court Cases
  {
    id: 'case-1',
    name: 'HC-2024-5678: ABC Construction Ltd vs Ministry of Transport',
    type: 'courtCase',
    aliases: ['HC-2024-5678', 'ABC vs MoT'],
    attributes: {
      court: 'High Court of Kenya',
      caseNumber: 'HC-2024-5678',
      status: 'Ongoing',
      year: 2024,
    },
    confidence: 0.99,
    sources: { government: 1, legal: 15, news: 8, audit: 0, social: 2 },
    connectionCount: 4,
    firstSeen: '2024-01-10',
    lastUpdated: '2024-03-01',
    position: { x: 100, y: -300 },
  },
  // Locations
  {
    id: 'location-1',
    name: 'Nairobi, Kenya',
    type: 'location',
    aliases: ['Nairobi'],
    attributes: {
      country: 'Kenya',
      region: 'Central',
      locationType: 'City',
    },
    confidence: 0.99,
    sources: { government: 10, legal: 5, news: 20, audit: 3, social: 5 },
    connectionCount: 10,
    firstSeen: '2021-01-01',
    lastUpdated: '2024-03-01',
    position: { x: -300, y: 300 },
  },
  // Audit Finding
  {
    id: 'audit-1',
    name: 'High-Risk Procurement Irregularities - Highway Contracts 2024',
    type: 'auditFinding',
    aliases: ['Audit 2024-Q1', 'Procurement Audit'],
    attributes: {
      auditYear: 2024,
      severity: 'High',
      category: 'Procurement',
      status: 'Under Review',
    },
    confidence: 0.91,
    sources: { government: 8, legal: 6, news: 3, audit: 12, social: 0 },
    connectionCount: 3,
    firstSeen: '2024-02-01',
    lastUpdated: '2024-03-01',
    position: { x: 300, y: -300 },
  },
];

export const EXAMPLE_GRAPH_EDGES: GraphEdge[] = [
  {
    id: 'edge-1',
    source: 'person-1',
    target: 'org-1',
    type: 'DIRECTS',
    confidence: 0.95,
    sources: [
      { type: 'government', url: 'https://example.com/doc1', date: '2023-01-15' },
      { type: 'news', url: 'https://example.com/news1', date: '2023-02-10' },
    ],
    firstSeen: '2022-02-01',
    lastVerified: '2024-03-01',
    contradictions: [],
  },
  {
    id: 'edge-2',
    source: 'person-2',
    target: 'org-1',
    type: 'LEADS',
    confidence: 0.88,
    sources: [
      { type: 'legal', url: 'https://example.com/doc2', date: '2023-05-15' },
    ],
    firstSeen: '2022-05-15',
    lastVerified: '2024-03-01',
    contradictions: [],
  },
  {
    id: 'edge-3',
    source: 'org-1',
    target: 'contract-1',
    type: 'WON',
    confidence: 0.98,
    sources: [
      { type: 'government', url: 'https://example.com/contract', date: '2023-06-15' },
      { type: 'news', url: 'https://example.com/news2', date: '2023-06-16' },
    ],
    firstSeen: '2023-06-15',
    lastVerified: '2024-03-01',
    contradictions: [],
  },
  {
    id: 'edge-4',
    source: 'org-2',
    target: 'contract-1',
    type: 'AWARDED',
    confidence: 0.99,
    sources: [
      { type: 'government', url: 'https://example.com/tender', date: '2023-06-15' },
    ],
    firstSeen: '2023-06-15',
    lastVerified: '2024-03-01',
    contradictions: [],
  },
  {
    id: 'edge-5',
    source: 'contract-1',
    target: 'project-1',
    type: 'FUNDS',
    confidence: 0.97,
    sources: [
      { type: 'government', url: 'https://example.com/project', date: '2023-03-01' },
    ],
    firstSeen: '2023-06-15',
    lastVerified: '2024-03-01',
    contradictions: [],
  },
  {
    id: 'edge-6',
    source: 'project-1',
    target: 'location-1',
    type: 'LOCATED_IN',
    confidence: 0.99,
    sources: [
      { type: 'government', url: 'https://example.com/location', date: '2023-03-01' },
    ],
    firstSeen: '2023-03-01',
    lastVerified: '2024-03-01',
    contradictions: [],
  },
  {
    id: 'edge-7',
    source: 'contract-1',
    target: 'case-1',
    type: 'SUBJECT_OF',
    confidence: 0.98,
    sources: [
      { type: 'legal', url: 'https://example.com/case', date: '2024-01-10' },
    ],
    firstSeen: '2024-01-10',
    lastVerified: '2024-03-01',
    contradictions: [],
  },
  {
    id: 'edge-8',
    source: 'contract-1',
    target: 'audit-1',
    type: 'AUDITED',
    confidence: 0.91,
    sources: [
      { type: 'audit', url: 'https://example.com/audit', date: '2024-02-01' },
    ],
    firstSeen: '2024-02-01',
    lastVerified: '2024-03-01',
    contradictions: [],
  },
  {
    id: 'edge-9',
    source: 'org-1',
    target: 'location-1',
    type: 'REGISTERED_IN',
    confidence: 0.96,
    sources: [
      { type: 'government', url: 'https://example.com/registry', date: '2022-01-15' },
    ],
    firstSeen: '2022-01-15',
    lastVerified: '2024-03-01',
    contradictions: [],
  },
  {
    id: 'edge-10',
    source: 'org-3',
    target: 'project-1',
    type: 'FUNDS',
    confidence: 0.94,
    sources: [
      { type: 'government', url: 'https://example.com/funding', date: '2023-03-01' },
    ],
    firstSeen: '2023-03-01',
    lastVerified: '2024-03-01',
    contradictions: [],
  },
];
